import { render, staticRenderFns } from "./InputTable.vue?vue&type=template&id=63b93f36"
import script from "./InputTable.vue?vue&type=script&lang=js"
export * from "./InputTable.vue?vue&type=script&lang=js"
import style0 from "./InputTable.vue?vue&type=style&index=0&id=63b93f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports